"use client";

import { c as _c } from "react/compiler-runtime";
import { isbot } from "isbot";
import { useEffect, useState } from "react";
import { useTrackingData } from "@/contexts/tracking/tracking.context";
import { jpmuidDefault } from "@/hooks/tracking/jpmuid/jpmuid";
import { uuidv4 } from "@/utilities/uuid/uuid";
import { useCookiebotConsent } from "@/vendors/Cookiebot/_hooks/use-cookiebot-consent.hook";
const uuidLength = 36;
export function useJpmuid() {
  const $ = _c(9);
  const {
    trackingData
  } = useTrackingData();
  const [jpmuid, setJpmuid] = useState(trackingData?.jpmuid ?? jpmuidDefault.anon);
  const {
    statistics,
    submitted
  } = useCookiebotConsent();
  let t0;
  if ($[0] !== jpmuid || $[1] !== statistics || $[2] !== submitted) {
    t0 = () => {
      if (isbot(navigator.userAgent)) {
        setJpmuid(jpmuidDefault.bot);
        return;
      }
      if (!submitted || statistics && jpmuid !== jpmuidDefault.anon) {
        return;
      }
      const jpmuidFromCookie = readJpmuidCookie();
      const newJpmuid = jpmuidFromCookie !== jpmuidDefault.anon ? jpmuidFromCookie : determineNewJpmuid(statistics);
      setJpmuid(newJpmuid);
      manageJpmuidCookie(newJpmuid, statistics);
    };
    $[0] = jpmuid;
    $[1] = statistics;
    $[2] = submitted;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== statistics || $[5] !== submitted) {
    t1 = [submitted, statistics];
    $[4] = statistics;
    $[5] = submitted;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  useEffect(t0, t1);
  let t2;
  if ($[7] !== jpmuid) {
    t2 = {
      jpmuid
    };
    $[7] = jpmuid;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function readJpmuidCookie(): string {
  const jpmuidFromCookie = document.cookie.split("; ").find(row => row.startsWith("jpmuid="))?.split("=")[1];
  const validJpmuid = typeof jpmuidFromCookie !== "undefined" && jpmuidFromCookie.length === uuidLength;
  return validJpmuid ? jpmuidFromCookie : jpmuidDefault.anon;
}
function manageJpmuidCookie(jpmuid: string, statistics: boolean) {
  // biome-ignore lint/suspicious/noDocumentCookie: This is necessary for cookie management
  document.cookie = statistics ? `jpmuid=${jpmuid}; Max-Age=31536000; ${cookieExpirationString(1)}; SameSite=None; Path=/; Secure;` : `jpmuid=; Expires=${cookieExpirationString(-1)}; Path=/;`;
}
function determineNewJpmuid(statistics: boolean) {
  return statistics ? uuidv4() : jpmuidDefault.anon;
}
function cookieExpirationString(years: number) {
  const date = new Date();
  date.setFullYear(date.getFullYear() + years);
  return `Expires=${date.toUTCString()}`;
}